export const FAVES_START_YEAR = 2025;

interface RuntimeConfig {
  web_base_url?: string;
}

const DEFAULT_FAVES_PUBLIC_WEB_BASE_URL = 'https://faves.xyz';

function readRuntimeConfig(): RuntimeConfig {
  if (typeof document === 'undefined') {
    return {};
  }

  const rawRuntimeConfig = document.getElementById('runtimeConfig')?.textContent;
  if (!rawRuntimeConfig) {
    return {};
  }

  try {
    return JSON.parse(rawRuntimeConfig) as RuntimeConfig;
  } catch {
    return {};
  }
}

const runtimeConfig = readRuntimeConfig();
const runtimePublicWebBaseUrl = runtimeConfig.web_base_url?.trim();

export const FAVES_PROD_BASE_URL = runtimePublicWebBaseUrl || DEFAULT_FAVES_PUBLIC_WEB_BASE_URL;
